import { FILTERS_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const getMostBuyFilters = () => {
  return myFetch(`${FILTERS_ENDPOINT}/popular/buy`, "GET");
};
